module.exports = __webpack_public_path__ + "static/media/coletando-informacoes.be8b805c.png";